export default "__VITE_ASSET__BAzBW$4J__"